export const OFFLINE_MODE_BANNER_TEXT = 'Offline mode – Limited functionality';
export const OFFLINE_MODE_BANNER_INFO_LABEL = 'More information about offline mode';
export const RETURN_TO_CLOUD_LABEL = 'Return to Cloud';
export const RETURN_TO_CLOUD_UNAVAILABLE_LABEL = 'Return to Cloud — cloud not reachable yet';
export const KEEP_TAB_OPEN_TEST_ID = 'offline-mode-keep-tab-open';

export const OFFLINE_MODE_BANNER_SLOT_TEST_ID = 'offline-mode-banner-slot';
export const ENTER_LOCAL_SERVER_LABEL = 'Open Offline Mode on this facility server';

export const OFFLINE_MODE_INFO_TITLE = 'Offline Mode';
export const OFFLINE_MODE_INFO_BODY =
  "You're connected to a separate backup environment. Messages sent here do not sync with your " +
  "main organization, and your main organization's message history may not be available.";
export const OFFLINE_MODE_KEEP_TAB_OPEN = 'Keep this tab open to receive messages.';
export const OFFLINE_MODE_INFO_DISMISS = 'Got it';

export const DISCARD_DRAFT_MODAL_TYPE = 'offlineModeDraft';
export const DISCARD_DRAFT_HEADER = 'Switch to Offline Mode?';
export const DISCARD_DRAFT_CONFIRM = 'DISCARD AND SWITCH';
export const DISCARD_DRAFT_CANCEL = 'KEEP DRAFT';
